import type { CustomerAccessRepository } from '#/domain/customerAccess/CustomerAccessRepository'

export class RevokeCustomerFeatureUseCase {
  constructor(private readonly repository: CustomerAccessRepository) {}

  execute(customerId: string, featureId: string): Promise<void> {
    return this.repository.revokeFeature(customerId, featureId)
  }
}
